import script from "./ContentHolder.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContentHolder.vue?vue&type=script&setup=true&lang=ts"

import "./ContentHolder.vue?vue&type=style&index=0&id=3157fd90&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3157fd90"]])

export default __exports__